import { useSyncExternalStore } from "react";

import { createThemeController } from "@akaike/design-system";

import { RETIRED_APPEARANCE_KEYS, THEME_STORAGE_KEY } from "./theme-keys";

export type { Theme, ThemePreference } from "@akaike/design-system";

export { THEME_STORAGE_KEY } from "./theme-keys";

const controller = createThemeController({
  storageKey: THEME_STORAGE_KEY,
  retiredStorageKeys: RETIRED_APPEARANCE_KEYS,
});

export const resolveTheme = controller.resolveTheme;
export const readPreference = controller.readPreference;
export const setPreference = controller.setPreference;
export const toggleTheme = controller.toggleTheme;

export function useTheme() {
  const theme = useSyncExternalStore(
    controller.subscribe,
    controller.readTheme,
    controller.getThemeServerSnapshot,
  );
  const preference = useSyncExternalStore(
    controller.subscribe,
    controller.readPreference,
    controller.getPreferenceServerSnapshot,
  );
  return {
    theme,
    preference,
    dark: theme === "control-room",
    setPreference,
    toggleTheme,
  };
}
